export const addUnSeenNotificationCount = count => ({
    type: 'ADD_UNSEEN_NOTIFICATION_COUNT',
    count
  })